<template>
  <div class="main-survey-div">
    <v-dialog
      v-model="dialog"
      width="300"
      persistent
      transition="dialog-bottom-transition"
      content-class="survey-dialog"
    >
      <v-card
        class="elevation-16 mx-auto survey-card"
      >
      <v-card-title class="text-break text-center d-flex justify-content-center">{{$t(`SatisfactionSurveyModal.questions.${functionality}.${question.text}`)}}</v-card-title>
        <v-card-text>
          <div class="text-center">
            <v-rating
              v-if="question.type == SATISFACTION_SURVEY.QUESTION_TYPE.RATING"
              v-model="rating"
              color="yellow darken-3"
              background-color="grey darken-1"
              empty-icon="$ratingFull"
              hover
              large
            />
            <template v-else-if="question.type == SATISFACTION_SURVEY.QUESTION_TYPE.OPTIONS">
              <v-checkbox
                v-for="(option, index) of question.options"
                :key="index"
                class="mt-0 mb-2"
                v-model="selectedCheckboxes"
                :label="$t(`SatisfactionSurveyModal.options.${option}`)"
                :value="option"
                hide-details
              />
              <v-textarea
                v-if="selectedCheckboxes.includes(SATISFACTION_SURVEY.OPTIONS.OTHER) || selectedCheckboxes.includes(SATISFACTION_SURVEY.OPTIONS.MISSING_DATA)"
                outlined
                v-model="text"
                no-resize
                auto-grow
                rows="1"
                hide-details
                :placeholder="selectedCheckboxes.includes(SATISFACTION_SURVEY.OPTIONS.MISSING_DATA) ? $t('SatisfactionSurveyModal.options.dataNeeded') : ''"
              />
            </template>
            <v-textarea
              v-else-if="question.type == SATISFACTION_SURVEY.QUESTION_TYPE.TEXT"
              outlined
              v-model="text"
              no-resize
              auto-grow
              rows="1"
              hide-details
            />

          </div>
        </v-card-text>
        <v-card-actions class="justify-space-between">
          <v-btn
            text
            @click="handleDecline"
            :loading="loadingDecline"
            :disabled="loadingConfirm"
          >
            {{declineBtnText || $t('SatisfactionSurveyModal.declineBtnText')}}
          </v-btn>
          <v-btn
            color="#0098E1"
            text
            :disabled="!isQuestionAnswered || loadingDecline"
            @click="handleConfirm"
            :loading="loadingConfirm"
          >
            {{confirmBtnText || $t('SatisfactionSurveyModal.confirmBtnText')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {SATISFACTION_SURVEY} from '../../constants/const'
export default {
  data () {
    return {
      rating: 0,
      text: '',
      selectedCheckboxes: [],
      questionIndex: 0,
      SATISFACTION_SURVEY,
      loadingConfirm: false,
      loadingDecline: false
    }
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    questions: {
      type: Array,
      default: () => []
    },
    declineBtnText: {
      type: String,
      default: ''
    },
    declineBtnCallback: {
      type: Function,
      default: () => {}
    },
    confirmBtnText: {
      type: String,
      default: ''
    },
    confirmBtnCallback: {
      type: Function,
      default: () => {}
    },
    functionality: {
      type: String,
      default: ''
    }
  },
  methods: {
    async handleConfirm () {
      try {
        this.loadingConfirm = true
        const BAD_RATING_THRESHOLD = 3
        let response = this.getQuestionResponse()
        await this.confirmBtnCallback(this.question, response)
        if (this.question.type === SATISFACTION_SURVEY.QUESTION_TYPE.RATING && this.rating < BAD_RATING_THRESHOLD) {
          // Next question
          this.questionIndex++
        } else {
          // Close dialog
          this.$emit('update:dialog', false)
        }
      } catch (error) {
        console.log(error.message)
      } finally {
        this.loadingConfirm = false
      }
    },
    async handleDecline () {
      try {
        this.loadingDecline = true
        await this.declineBtnCallback()
      } catch (error) {
        console.log(error.message)
      } finally {
        this.loadingDecline = false
        this.$emit('update:dialog', false)
      }
    },
    getQuestionResponse () {
      switch (this.question.type) {
        case SATISFACTION_SURVEY.QUESTION_TYPE.RATING: {
          return this.rating
        }
        case SATISFACTION_SURVEY.QUESTION_TYPE.OPTIONS: {
          return {
            checks: [...this.selectedCheckboxes],
            text: this.text
          }
        }
        case SATISFACTION_SURVEY.QUESTION_TYPE.TEXT: {
          return this.text
        }
      }
    }
  },
  computed: {
    question () {
      return this.questions[this.questionIndex]
    },
    isQuestionAnswered () {
      switch (this.question.type) {
        case SATISFACTION_SURVEY.QUESTION_TYPE.RATING:
          return !!this.rating
        case SATISFACTION_SURVEY.QUESTION_TYPE.OPTIONS:
          return !!this.selectedCheckboxes.length
        case SATISFACTION_SURVEY.QUESTION_TYPE.TEXT:
          return !!this.text.length
      }
    }
  }
}
</script>

<style>
.main-survey-div {
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
}
.survey-card {
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
.survey-dialog {
  position: fixed;
  bottom: 0;
  margin-bottom: 0;
  border-radius: 0px !important;
}
</style>


// WEBPACK FOOTER //
// SatisfactionSurveyModal.vue?f7355fa4